<template>
    <div class="construction-projects-view">
        <div class="construction-projects-view__filters">
            <BaseInput
                v-model="filterSearch"
                :debounce="400"
                :placeholder="$t('filterByQuery')"
                block
            >
                <template #icon>
                    <SearchIcon width="16" height="16" />
                </template>
            </BaseInput>

            <BaseMultiselect
                v-model="filterLocation"
                :placeholder="$t('filterByLocation')"
                :options="locationsSortedByName"
                track-by="id"
                label="name"
                multiple
                block
            />
        </div>

        <div class="construction-projects-view__content">
            <ConstructionProjectsTableView
                :filter-location="filterLocation"
                :filter-search="filterSearch"
                @clearFilter="
                    filterLocation = []
                    filterSearch = ''
                "
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseInput from '../redesigned/BaseInput'
import BaseMultiselect from '../redesigned/BaseMultiselect'
import ConstructionProjectsTableView from './ConstructionProjectsTableView'
import SearchIcon from '../icons/SearchIcon'

export default {
    name: 'ConstructionProjectsView',
    components: {
        BaseInput,
        BaseMultiselect,
        ConstructionProjectsTableView,
        SearchIcon,
    },
    data() {
        return {
            filterLocation: [],
            filterSearch: '',
        }
    },
    computed: {
        ...mapGetters('location', ['locationsSortedByName']),
    },
}
</script>

<i18n>
{
    "en": {
        "filterByLocation": "Location",
        "filterByQuery": "Name, Adresse oder Auftragsnummer"
    },
    "de": {
        "filterByLocation": "Standort",
        "filterByQuery": "Name, Adresse oder Auftragsnummer"
    },
    "fr": {
        "filterByLocation": "Emplacement",
        "filterByQuery": "Nom, adresse ou numéro de commande"
    },
    "it": {
        "filterByLocation": "Locazione",
        "filterByQuery": "Name, Adresse oder Auftragsnummer"
    }
}
</i18n>

<style lang="scss" scoped>
.construction-projects-view {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &__filters {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        padding: 1.5rem 1rem 0.5rem 2rem;
        background-color: $color-gray-lighter-new;
        border-bottom: $style-border;

        & > * {
            margin-right: 1rem;
            margin-bottom: 1rem;
            max-width: 200px;
        }

        .base-multiselect {
            max-width: 240px;
        }
    }

    &__content {
        display: flex;
        overflow-y: auto;

        & > * {
            width: 100%;
            overflow-x: auto;
        }
    }

    @include respond-to('for-small-mobile-only') {
        &__filters {
            padding: 1rem 1rem 0;

            & > * {
                &:not(.base-button) {
                    margin-right: 0;
                    max-width: 100%;
                    width: 100%;
                }
            }
        }
    }
}
</style>
